module.exports = __webpack_public_path__ + "assets/grab-arrow-right.d480f645.svg";